import { getLocalizedDomainRelationPath } from "csi/service/localeService";
import StoreNodesConstructor, { StoreNodes } from "csi/store/Nodes";
import Widget from "csi/table/Widget";
import { C8Node } from "csi/typings";
import { QueryLevel } from "csi/view/_query/Level";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

interface SpecNode extends C8Node {
	DomainPath: string;
}

const CustomViewAttributeTable = declare(Widget, {

	/** @property {boolean} bResetStore - false indicates that store is controlled by code below  */
	bResetStore: false,

	/** @property {string[]} findAttributes - find results by this attribute  */
	findAttributes: ["Node Name"],

	/** @property {string[]} plugins - available plugins  */
	plugins: ["find"],

	/** @property {dojo._base.DeclareConstructor | null} prefClass - set to null for minimal table view  */
	prefClass: null,

	/** @property {string} typeClass - class type for attributes */
	typeClass: null,

	/** @property {Spec[]} specs - specs of attributes */
	specs: null,

	/**
	 * @override
	 * Add function to store to augment items with localized names so they can be filtered and sorted.
	 */
	onCreateMainQueryLevel(ql: QueryLevel): void {
		ql.createCustomStore = (): StoreNodes => {
			let attributeKeys = [];
			const { specs } = this;

			// the user may doesn't pick any attributes yet, add check here
			specs?.forEach((spec) => {
				const node = xml.nodeCreateClientNode(spec.getKey()) as SpecNode;

				// set key on node, make sure it's consistent with the one in the table view
				node.Key = spec.getKey();

				// get extended path from spec and use that to set display name of path
				const ep = spec.getExtendedPath();
				if (ep) {
					node.DomainPath = getLocalizedDomainRelationPath(ep);
				}

				// set name on node
				xml.nodeSetName(node, spec.name);

				// push node to attribute list
				attributeKeys.push(node);
			});

			attributeKeys = xml.sortNodes(attributeKeys);

			const nameStore = new StoreNodesConstructor({
				// have to specify this to make the find feature work
				bSimpleQueryEngine: true,
				cachingStore: this.cacheView,
				data: attributeKeys,
				querySpecStore: this.get("querySpecStore"),
			});

			return nameStore;
		};
	},
});

export = CustomViewAttributeTable;